import * as React from "react";
import { Container, Navbar, NavbarBrand, NavbarToggler, Collapse, Nav, NavItem, NavLink } from "reactstrap";
import BankList from "./components/bankList";
import BankDetails from "./components/bankDetails";
import NoticeScreen from "./components/accessNotice/NoticeScreen";
import logo from "../common/assets/fdic/internal/images/FDIC_Logo.png";
import helpIcon from "../common/assets/fdic/internal/images/outline-help_outline-24px.svg";
import exitIcon from "../common/assets/fdic/internal/images/outline-highlight_off-24px.svg";
import { Constants } from "./constants";
import { UserContext } from './components/common/UserContext';
import axios from 'axios';

import "../common/styles/internalApp.css";

interface AppState {
  hasUserAccepted: boolean;
  userRole: string;
  isOpen: boolean;
}

class App extends React.Component<any, AppState> {
  constructor(props: any) {
    super(props);

    this.state = {
      hasUserAccepted: false,
      userRole: '',
      isOpen: false
    };
    this.handelUserAcceptance = this.handelUserAcceptance.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentWillMount() {
     var publicHeaderDiv = document.getElementById("div_fdic_standard_header");
     if (publicHeaderDiv) {
       publicHeaderDiv.hidden=true;
     }
     var publicFooterDiv = document.getElementById("div_fdic_standard_footer");
     if (publicFooterDiv) {
       publicFooterDiv.hidden = true;
     }
  }

  componentDidMount() {
    // remove public overlay
    let overlay = document.getElementById("overlayFix");
    if( overlay ) overlay.style.display = "none";
    document.body.classList.remove("setup");
    this.getUserRole();
  }

  getUserRole() {
    const UserInfoURI = Constants.BANKLIST_USER_URI
    axios
      .get(UserInfoURI)
      .then((data : any) => {
        if (data.isReadOnly) {
          this.setState({userRole:'Read Only'});
        } else {
          this.setState({ userRole: 'Admin'});
        }

      })
      .catch(err => {
        console.log(err);
        return null;
      });

  }
  handelUserAcceptance() {
    this.setState({
      hasUserAccepted: true
    });
  }

  isBankSelected = () => {
    let isSelected = false;
    if (this.props.match && this.props.match.params.id) {
      isSelected = true;
    }
    return isSelected;
  };

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  public render() {
    let content = <NoticeScreen onAction={this.handelUserAcceptance} />;
    if (this.state.hasUserAccepted) {
      if (this.isBankSelected()) {
        content = <BankDetails bankid={this.props.match.params.id} />;
      } else {
        content = <BankList type={this.props.match.params.type} />;
      }
    }

    return (
      <Container fluid className="internalFDIC">
        <header>
          <Navbar expand="md">
            <NavbarBrand href="/drripbal"><img src={logo} alt="Federal Deposit Isurance Application Logo"/>DRRIPBAL</NavbarBrand>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
                <NavItem>
                  <span>{this.context.name}&nbsp;</span>
                </NavItem>
                <NavItem>
                  <span> ( {this.context.isReadOnly === true ? 'Read Only' : 'Admin'} )</span>
                </NavItem>
                <NavItem>
                  <NavLink href={Constants.URI_HELP}><img src={helpIcon} alt="Application Help"/><span className="hideVisually">Help</span></NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href={Constants.URI_LOGOUT}><img src={exitIcon} alt="Logout" /><span className="hideVisually">Logout</span></NavLink>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>
          <div>
            &nbsp;
          </div>
        </header>
        <main id="content">
          {content}
        </main>
        <div className="footter">
        </div>
      </Container>
    );
  }
}
App.contextType = UserContext;
export default App;
